<div [hidden]="!ViewReady" fxLayout="row" fxLayoutAlign="start start">
    <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="100">
        <!--  [fxFlex]="User.CurrentRole === 'Superintendent' ? 40 : 100" -->
        <h2>Current Notifications</h2>
        <div *ngIf="LastLogin" class="margin-bottom">
            You last logged in to the IRIS system on {{ LastLogin | date: 'MMM. d, yyyy' }} ({{ LastLogin | date: 'h:mm a' }}).
        </div>
        <div *ngIf="Notifications && !!Notifications.length" class="fullwidth">
            <div
                *ngFor="let item of Notifications"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                class="margin-bottom"
            >
                <mat-icon matListIcon>{{ item.IconName || 'notifications' }}</mat-icon>
                <div fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                    <span class="mat-h4-nomargin" [innerHTML]="item.Message | safeHTML"></span>
                </div>
                <button
                    type="button"
                    *ngIf="item.Details && !!item.Details.length"
                    mat-raised-button
                    color="primary"
                    (click)="ShowNotificationDetails(item.Details)"
                >
                    Details...
                </button>
            </div>
        </div>
        <div *ngIf="!Notifications || !Notifications.length"><em>There are no new notifications available at this time.</em></div>
        <div fxHide.gt-md class="mat-caption navreminder">
            <em
                >Access the menu panel by clicking the <mat-icon>menu</mat-icon> button in the upper-left corner of this
                application.</em
            >
        </div>
    </div>
    <!-- <div fxLayout="column" fxLayoutAlign="start start" fxFlex="60" *ngIf="User.CurrentRole === 'Superintendent'" fxShow.gt-lg>
        <h2>Current System Summary</h2>
        <table
            class="summarytable"
            border="0"
            cellpadding="0"
            cellspacing="0"
            *ngFor="let stat of SummaryStats; first as $first"
            [class.margin-top]="!$first"
        >
            <thead>
                <tr>
                    <th colspan="6">{{ stat.RequestSource }} Requests</th>
                </tr>
                <tr>
                    <th>Priority</th>
                    <th>Unassigned</th>
                    <th>Unanswered</th>
                    <th>Answered</th>
                    <th>Completed</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                <tr class="warnbackground500">
                    <td>Urgent</td>
                    <td>{{ stat.UrgentUnassigned }} ({{ stat.UrgentUnassignedPercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.UrgentUnanswered }} ({{ stat.UrgentUnansweredPercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.UrgentAnswered }} ({{ stat.UrgentAnsweredPercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.UrgentComplete }} ({{ stat.UrgentCompletePercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.UrgentCount }}</td>
                </tr>
                <tr class="warnbackground200">
                    <td>High</td>
                    <td>{{ stat.HighUnassigned }} ({{ stat.HighUnassignedPercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.HighUnanswered }} ({{ stat.HighUnansweredPercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.HighAnswered }} ({{ stat.HighAnsweredPercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.HighComplete }} ({{ stat.HighCompletePercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.HighCount }}</td>
                </tr>
                <tr class="accentbackground500">
                    <td>Routine</td>
                    <td>{{ stat.RoutineUnassigned }} ({{ stat.RoutineUnassignedPercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.RoutineUnanswered }} ({{ stat.RoutineUnansweredPercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.RoutineAnswered }} ({{ stat.RoutineAnsweredPercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.RoutineComplete }} ({{ stat.RoutineCompletePercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.RoutineCount }}</td>
                </tr>
                <tr class="accentbackground200">
                    <td>Low</td>
                    <td>{{ stat.LowUnassigned }} ({{ stat.LowUnassignedPercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.LowUnanswered }} ({{ stat.LowUnansweredPercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.LowAnswered }} ({{ stat.LowAnsweredPercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.LowComplete }} ({{ stat.LowCompletePercent | number: '1.1-1' }}%)</td>
                    <td>{{ stat.LowCount }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr class="primarybackground500">
                    <th>Totals</th>
                    <th>{{ stat.AllUnassigned }} ({{ stat.AllUnassignedPercent | number: '1.1-1' }}%)</th>
                    <th>{{ stat.AllUnanswered }} ({{ stat.AllUnansweredPercent | number: '1.1-1' }}%)</th>
                    <th>{{ stat.AllAnswered }} ({{ stat.AllAnsweredPercent | number: '1.1-1' }}%)</th>
                    <th>{{ stat.AllComplete }} ({{ stat.AllCompletePercent | number: '1.1-1' }}%)</th>
                    <th>{{ stat.TotalCount }}</th>
                </tr>
            </tfoot>
        </table>
    </div> -->
</div>
